// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.portal-wscn-http404-container[data-v-6faa5672] {\r\n  flex-grow: 1;\r\n  padding: 22px;\r\n  box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);\r\n  background: rgba(255, 255, 255, 0.65);\r\n  border-radius: 6px;\n}\r\n", ""]);
// Exports
module.exports = exports;
